import { Settings } from "lucide-react";

const UpdateInProgress = () => (
  <div className="min-h-screen bg-black flex items-center justify-center p-4" data-testid="update-in-progress-screen">
    <div className="text-center max-w-md">
      <Settings className="w-24 h-24 text-[#EFDF00] mx-auto mb-8 animate-[spin_3s_linear_infinite]" strokeWidth={1.8} />
      <h1 className="font-nouvel text-4xl text-white mb-5">Auto Thurm</h1>
      <div className="bg-[#EFDF00] p-6 mb-6">
        <h2 className="font-read font-bold text-lg text-black uppercase mb-2">Gleich wieder da</h2>
        <p className="font-read text-black">
          Wir führen im Moment ein Update durch. Die Seite lädt automatisch neu, sobald wir fertig sind.
        </p>
        <div className="flex justify-center gap-2 mt-4">
          {[0, 200, 400].map((d) => (
            <span key={d} className="w-2 h-2 bg-black rounded-full animate-pulse" style={{ animationDelay: `${d}ms` }} />
          ))}
        </div>
      </div>
      <div className="text-[#888B8D] font-read text-sm">
        <p>Bei dringenden Anfragen erreichen Sie uns unter:</p>
        <p className="text-white mt-2 font-bold">Tel: 09682 722</p>
      </div>
    </div>
  </div>
);

export default UpdateInProgress;
